// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1MOL-","imgContainer":"Header_imgContainer__33WSk","imgBox":"Header_imgBox__tCdFi","img":"Header_img__21Pvn","overlay":"Header_overlay__28knl"};